import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../lib/api";
import { SOURCE_KEY, fmtDateTime } from "./AdminUsersTab";

const tierLabel = (snap) => (snap?.tier || "free").toUpperCase();

export default function PlanHistory({ uid, reloadKey, t }) {
  const { i18n } = useTranslation();
  const fmt = (iso) => fmtDateTime(iso, i18n.language);
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get(`/admin/users/${uid}/plan-changes`).then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, [uid, reloadKey]);

  if (rows === null) return <div className="text-xs text-slate-500">{t("common.loading")}</div>;
  if (!rows.length) return <div className="text-xs text-slate-500" data-testid="plan-history-empty">{t("admin.planHistoryEmpty")}</div>;
  return (
    <ul className="space-y-2" data-testid="plan-history">
      {rows.map((e) => (
        <li key={e.id} className="text-xs border-l-2 border-slate-700 pl-3" data-testid={`plan-change-${e.id}`}>
          <div className="text-slate-200 font-mono-data">
            {tierLabel(e.previous)} → {tierLabel(e.new)}
            {e.new?.premium_source && SOURCE_KEY[e.new.premium_source] ? ` · ${t(SOURCE_KEY[e.new.premium_source])}` : ""}
          </div>
          <div className="text-slate-500">
            {fmt(e.created_at)} · {t(`admin.reasons.${e.reason}`, { defaultValue: e.reason })} · {e.actor_email || t("admin.bySystem")}
          </div>
        </li>
      ))}
    </ul>
  );
}
